import fetchClient from "./api";

export function login(data) {
  return fetchClient.post("/auth/login", data);
}

export function register(data) {
  return fetchClient.post("/auth/register", data);
}

export function checkToken() {
  return fetchClient.get("/auth/check-token");
}

export function verifyEmail(token) {
  return fetchClient.get(`/auth/verify-email?token=${token}`);
}

export function resendVerificationEmail(email) {
  return fetchClient.post("/auth/resend-verification", { email });
}